var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 324.2",
    style: {
      enableBackground: "new 0 0 500 324.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437.5,186.5c0-0.1,0-0.2,0-0.3c0-55.2-44.7-99.9-99.9-99.9c-55.2,0-99.9,44.7-99.9,99.9c0,0.1,0,0.2,0,0.3 c-35,2.9-62.5,32.2-62.5,68v1.4c0,37.7,30.6,68.3,68.3,68.3h188.2c37.7,0,68.3-30.6,68.3-68.3v-1.4 C500,218.7,472.5,189.5,437.5,186.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.3,58.2c0-0.1,0-0.1,0-0.2c0-32-26-58-58-58c-32,0-58,26-58,58c0,0.1,0,0.1,0,0.2C16,59.9,0,76.9,0,97.7 v0.8c0,21.9,17.7,39.6,39.6,39.6H149c21.9,0,39.6-17.7,39.6-39.6v-0.8C188.6,76.9,172.6,59.9,152.3,58.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.86881935fef51303ded820a18ebb41ad.svg";
export { ForwardRef as ReactComponent };